import { initializeForm } from '../../utils/form';
import {
  validateMobileNumber,
  validateNotEmpty,
  validatePasswordComplexity,
  validatePasswordRequiredIfNewNotEmpty,
} from '../../utils/validators';

$(() => {
  const myInfoFormSelector = $('#my-information-form');
  const securityFormSelector = $('#security-form');

  initializeForm(myInfoFormSelector, {
    initialValues: {
      postal: $("input[name='postal']").val(),
      address: $("input[name='address']").val(),
      'last-name': $("input[name='last-name']").val(),
      'first-name': $("input[name='first-name']").val(),
    },
    validate: (values) => {
      const errors = {
        ...validateNotEmpty(values, [
          'address',
          'postal',
          'last-name',
          'first-name',
        ]),
      };
      const hasErrors = !$.isEmptyObject(errors);
      $('#my-information-form-button').attr('disabled', hasErrors);

      return errors;
    },
    preventDefault: false,
  });

  initializeForm(securityFormSelector, {
    initialValues: {
      'code-phone-number': $("select[name='code-phone-number']").val(),
      email: $("input[name='email']").val(),
      phone: $("input[name='phone']").val(),
    },
    fieldsToValidateWithoutTouch: ['password'],
    validate: (values) => {
      const errors = {
        ...validateMobileNumber(values),
        ...validatePasswordComplexity(values),
        ...validatePasswordRequiredIfNewNotEmpty(values),
      };

      const hasErrors = !$.isEmptyObject(errors);
      $('#security-form-button').attr('disabled', hasErrors);

      return errors;
    },
    preventDefault: false,
    passwordHintField: 'new-password',
  });
});
